import { useState, useCallback } from 'react';
import {getHomePageTel} from "@/services/homeApi";

export default function useGlobalData() {
    const [data, setData] = useState<any>(null);
    // 更新全局数据的方法
    const fetchIndexTelData = useCallback(async () => {
        const response = await getHomePageTel();
        if(response.status === 1){
            setData(response.data)
        }
    }, []);

    return {
        data,
        fetchIndexTelData,
    };
}